import api from './api';

const appendFilters = (params, filters = {}) => {
  if (filters.fromDate) params.append('fromDate', filters.fromDate);
  if (filters.toDate) params.append('toDate', filters.toDate);
  if (filters.year) params.append('year', filters.year);
  if (filters.country) params.append('country', filters.country);
  if (filters.jobRole) params.append('jobRole', filters.jobRole);
  if (filters.applicant) params.append('applicant', filters.applicant);
  if (filters.paymentType) params.append('paymentType', filters.paymentType);
};

const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

const financeService = {
  async getDashboard(filters = {}) {
    const params = new URLSearchParams();
    appendFilters(params, filters);
    const response = await api.get(`/chairman/finance/dashboard?${params.toString()}`);
    return response.data;
  },

  async getTransactions(filters = {}, page = 1, limit = 20) {
    const params = new URLSearchParams();
    appendFilters(params, filters);
    params.append('page', String(page));
    params.append('limit', String(limit));

    const response = await api.get(`/chairman/finance/transactions?${params.toString()}`);
    return response.data;
  },

  async refundTransaction(payload) {
    const response = await api.post('/chairman/finance/refund', payload);
    return response.data;
  },

  async getRefundRequests(filters = {}) {
    const params = new URLSearchParams();
    appendFilters(params, filters);
    if (filters.status) {
      params.append('status', filters.status);
    }
    const response = await api.get(`/chairman/finance/refund-requests?${params.toString()}`);
    return response.data;
  },

  async reviewRefundRequest(applicationId, payload) {
    const response = await api.post(`/chairman/finance/refund-requests/${applicationId}/review`, payload);
    return response.data;
  },

  async exportPdf(filters = {}) {
    const params = new URLSearchParams();
    appendFilters(params, filters);
    const response = await api.get(`/chairman/finance/export/pdf?${params.toString()}`, {
      responseType: 'blob'
    });
    downloadFile(response.data, `chairman-finance-${Date.now()}.pdf`);
  },

  async exportExcel(filters = {}) {
    const params = new URLSearchParams();
    appendFilters(params, filters);
    const response = await api.get(`/chairman/finance/export/excel?${params.toString()}`, {
      responseType: 'blob'
    });
    downloadFile(response.data, `chairman-finance-${Date.now()}.xlsx`);
  }
};

export default financeService;
